import * as React from 'react';
import React__default from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled from 'styled-components';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;
var IconContainer = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  vertical-align: top;\n\n  svg {\n    display: block;\n    fill: ", ";\n    stroke: ", ";\n\n    &:not(:root) {\n      overflow: hidden;\n    }\n  }\n"])), function (p) {
  return !p.$fill ? 'none' : p.$color;
}, function (p) {
  return !p.$stroke ? 'none' : p.$color;
});

var _excluded = ["className", "width", "height", "source", "fill", "stroke", "color"];
function Icon(_ref) {
  var className = _ref.className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 16 : _ref$height,
      Source = _ref.source,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? true : _ref$fill,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? false : _ref$stroke,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(IconContainer, _extends({
    className: className,
    $fill: fill,
    $stroke: stroke,
    $color: color
  }, props), /*#__PURE__*/React.createElement(Source, {
    width: width,
    height: height
  })));
}

var ArrowDownSvg = function ArrowDownSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M7.78954 0.491786C7.51012 0.212373 7.05876 0.212373 6.77935 0.491786L3.99955 3.27159L1.21975 0.491786C0.940333 0.212373 0.488973 0.212373 0.20956 0.491786C-0.0698528 0.771199 -0.0698528 1.22256 0.20956 1.50197L3.49804 4.79045C3.77745 5.06986 4.22881 5.06986 4.50822 4.79045L7.7967 1.50197C8.06895 1.22972 8.06895 0.771199 7.78954 0.491786Z"
  }));
};

ArrowDownSvg.defaultProps = {
  width: "8",
  height: "5",
  viewBox: "0 0 8 5",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg"
};
function ArrowDownIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: ArrowDownSvg
  }, props));
}

var ArrowLeftSvg = function ArrowLeftSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M4.50821 7.78954C4.78763 7.51012 4.78763 7.05876 4.50821 6.77935L1.72841 3.99955L4.50821 1.21975C4.78763 0.940333 4.78763 0.488973 4.50821 0.20956C4.2288 -0.0698528 3.77744 -0.0698528 3.49803 0.20956L0.209551 3.49804C-0.0698619 3.77745 -0.0698619 4.22881 0.209551 4.50822L3.49803 7.7967C3.77028 8.06895 4.2288 8.06895 4.50821 7.78954Z"
  }));
};

ArrowLeftSvg.defaultProps = {
  width: "5",
  height: "8",
  viewBox: "0 0 5 8",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg"
};
function ArrowLeftIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: ArrowLeftSvg
  }, props));
}

var ArrowRightSvg = function ArrowRightSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29022 5.31134L1.69722 0.792288C1.60564 0.700338 1.49643 0.627164 1.37593 0.576996C1.25542 0.526828 1.126 0.500663 0.995151 0.500012C0.864302 0.499362 0.734621 0.52424 0.613605 0.573207C0.492589 0.622175 0.382639 0.694261 0.290114 0.785296C0.197589 0.876331 0.124324 0.98451 0.0745554 1.10358C0.0247865 1.22265 -0.000497818 1.35024 0.000163078 1.47898C0.000823975 1.60772 0.0274177 1.73506 0.0784063 1.85362C0.129395 1.97219 0.203766 2.07964 0.297221 2.16975L4.19722 6.00696L0.297221 9.84417C0.114657 10.0275 0.0129876 10.2742 0.0143051 10.5309C0.0156226 10.7875 0.11982 11.0332 0.304256 11.2147C0.488693 11.3962 0.738463 11.4987 0.999292 11.5C1.26012 11.5013 1.51093 11.4013 1.69722 11.2216L6.29022 6.70356C6.47769 6.51905 6.58301 6.26884 6.58301 6.00794C6.58301 5.74705 6.47769 5.49683 6.29022 5.31232V5.31134Z"
  }));
};

ArrowRightSvg.defaultProps = {
  width: "7",
  height: "12",
  viewBox: "0 0 7 12",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg"
};
function ArrowRightIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: ArrowRightSvg
  }, props));
}

var CalendarSvg = function CalendarSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("line", {
    x1: "10.75",
    y1: "3.25",
    x2: "10.75",
    y2: "0.75",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "8.75",
    y1: "9.25",
    x2: "10.25",
    y2: "9.25",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "0.75",
    y: "1.75",
    width: "12.5",
    height: "10.5",
    rx: "1.25",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "1",
    y1: "5.25",
    x2: "13",
    y2: "5.25",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React__default.createElement("line", {
    x1: "3.25",
    y1: "3.25",
    x2: "3.25",
    y2: "0.75",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }));
};

CalendarSvg.defaultProps = {
  width: "14",
  height: "13",
  viewBox: "0 0 14 13",
  stroke: "black",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function CalendarIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: CalendarSvg,
    fill: false,
    stroke: true
  }, props));
}

var CheckedSvg = function CheckedSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M1 3.14286L4.91304 7L11 1",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }));
};

CheckedSvg.defaultProps = {
  width: "12",
  height: "9",
  viewBox: "0 0 12 9",
  fill: "none",
  stroke: 'black',
  xmlns: "http://www.w3.org/2000/svg"
};
function CheckedIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: CheckedSvg,
    fill: false,
    stroke: true
  }, props));
}

var CloseSvg = function CloseSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M11.7614 10.6091C12.0795 10.9273 12.0795 11.4432 11.7614 11.7614C11.4432 12.0795 10.9273 12.0795 10.6091 11.7614L0.238644 1.39091C-0.079547 1.07272 -0.0795472 0.556834 0.238644 0.238643C0.556835 -0.0795477 1.07272 -0.0795477 1.39092 0.238643L11.7614 10.6091Z"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M10.6091 0.238644C10.9273 -0.0795471 11.4432 -0.0795472 11.7614 0.238644C12.0795 0.556835 12.0795 1.07272 11.7614 1.39091L1.39091 11.7614C1.07272 12.0795 0.556834 12.0795 0.238643 11.7614C-0.0795477 11.4432 -0.0795477 10.9273 0.238643 10.6091L10.6091 0.238644Z"
  }));
};

CloseSvg.defaultProps = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg"
};
function CloseIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: CloseSvg
  }, props));
}

var SearchSvg = function SearchSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M15.7656 14.6895L10.6934 9.61719C11.4805 8.59961 11.9062 7.35547 11.9062 6.04688C11.9062 4.48047 11.2949 3.01172 10.1895 1.9043C9.08398 0.796875 7.61133 0.1875 6.04688 0.1875C4.48242 0.1875 3.00977 0.798828 1.9043 1.9043C0.796875 3.00977 0.1875 4.48047 0.1875 6.04688C0.1875 7.61133 0.798828 9.08398 1.9043 10.1895C3.00977 11.2969 4.48047 11.9062 6.04688 11.9062C7.35547 11.9062 8.59766 11.4805 9.61523 10.6953L14.6875 15.7656C14.7024 15.7805 14.72 15.7923 14.7395 15.8004C14.7589 15.8084 14.7797 15.8126 14.8008 15.8126C14.8218 15.8126 14.8427 15.8084 14.8621 15.8004C14.8815 15.7923 14.8992 15.7805 14.9141 15.7656L15.7656 14.916C15.7805 14.9011 15.7923 14.8835 15.8004 14.864C15.8084 14.8446 15.8126 14.8238 15.8126 14.8027C15.8126 14.7817 15.8084 14.7609 15.8004 14.7414C15.7923 14.722 15.7805 14.7043 15.7656 14.6895ZM9.14062 9.14062C8.3125 9.9668 7.21484 10.4219 6.04688 10.4219C4.87891 10.4219 3.78125 9.9668 2.95312 9.14062C2.12695 8.3125 1.67188 7.21484 1.67188 6.04688C1.67188 4.87891 2.12695 3.7793 2.95312 2.95312C3.78125 2.12695 4.87891 1.67188 6.04688 1.67188C7.21484 1.67188 8.31445 2.125 9.14062 2.95312C9.9668 3.78125 10.4219 4.87891 10.4219 6.04688C10.4219 7.21484 9.9668 8.31445 9.14062 9.14062Z"
  }));
};

SearchSvg.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg"
};
function SearchIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: SearchSvg
  }, props));
}

var ErrorSvg = function ErrorSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M9.99069 13.552C9.67069 13.552 9.42002 13.632 9.23869 13.792C9.06802 13.952 8.98269 14.176 8.98269 14.464C8.98269 15.072 9.31869 15.376 9.99069 15.376C10.6627 15.376 10.9987 15.072 10.9987 14.464C10.9987 13.856 10.6627 13.552 9.99069 13.552ZM9.99069 3.904C9.45735 3.904 9.19069 4.19733 9.19069 4.784V11.024C9.19069 11.6 9.45735 11.888 9.99069 11.888C10.5347 11.888 10.8067 11.6 10.8067 11.024V4.784C10.8067 4.19733 10.5347 3.904 9.99069 3.904Z",
    fill: "white"
  }));
};

ErrorSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: 'black',
  xmlns: "http://www.w3.org/2000/svg"
};
function ErrorIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: ErrorSvg
  }, props));
}

var OkSvg = function OkSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.52023 9.68198C7.22186 9.39467 6.74708 9.40362 6.45976 9.70199C6.17244 10.0004 6.1814 10.4751 6.47977 10.7625L7.52023 9.68198ZM8.84615 12L8.32592 12.5402C8.61636 12.8199 9.07595 12.8199 9.36639 12.5402L8.84615 12ZM13.5202 8.54024C13.8186 8.25292 13.8276 7.77814 13.5402 7.47977C13.2529 7.1814 12.7781 7.17244 12.4798 7.45976L13.5202 8.54024ZM6.47977 10.7625L8.32592 12.5402L9.36639 11.4598L7.52023 9.68198L6.47977 10.7625ZM9.36639 12.5402L13.5202 8.54024L12.4798 7.45976L8.32592 11.4598L9.36639 12.5402Z",
    fill: "white"
  }));
};

OkSvg.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg"
};
function OkIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: OkSvg
  }, props));
}

var NotFoundSvg = function NotFoundSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("circle", {
    cx: "35.5",
    cy: "45.5",
    r: "31.5",
    fill: "#AFB4BF"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "35.5",
    cy: "41.5",
    r: "31.5",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "35.5",
    cy: "41.5",
    r: "31.5",
    fill: "url(#paint0_linear_345_1127)"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M22.2094 53.7477C28.0222 54.9644 34.2285 54.2483 39.7621 51.4408L57.1878 75.2314C58.5966 77.1516 61.2999 77.5762 63.229 76.1693C65.1518 74.7624 65.577 72.0627 64.1682 70.1361L46.7362 46.3456C55.76 37.2007 57.0799 22.6184 49.2428 11.9209C40.5363 0.0383024 23.834 -2.54735 11.9355 6.14121C0.0370197 14.8361 -2.55209 31.5161 6.14808 43.3987C8.04549 45.9907 10.33 48.1454 12.862 49.8312M11.7705 39.2984C18.2052 48.082 30.5542 49.9959 39.3559 43.5698C48.1513 37.1437 50.0677 24.8112 43.633 16.0212",
    stroke: "#AFB4BF",
    strokeWidth: "2",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "paint0_linear_345_1127",
    x1: "28.9946",
    y1: "33.9279",
    x2: "61.3322",
    y2: "66.3451",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: "#EAEEF4"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "1",
    stopColor: "#EAEEF4",
    stopOpacity: "0"
  }))));
};

NotFoundSvg.defaultProps = {
  width: "67",
  height: "78",
  viewBox: "0 0 67 78",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function NotFoundIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: NotFoundSvg,
    fill: false
  }, props));
}

var AttentionSvg = function AttentionSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("g", {
    clipPath: "url(#clip0_157_231)"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M36.4737 12.5C40.7076 5.16667 51.2924 5.16667 55.5263 12.5L81.507 57.5C85.741 64.8333 80.4486 74 71.9808 74H20.0192C11.5514 74 6.25906 64.8333 10.493 57.5L36.4737 12.5Z",
    fill: "#B8C4DA"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M33.0718 4C36.151 -1.33333 43.849 -1.33333 46.9282 4L78.1051 58C81.1843 63.3333 77.3353 70 71.1769 70H8.82309C2.66468 70 -1.18432 63.3333 1.89488 58L33.0718 4Z",
    fill: "white"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M33.0718 4C36.151 -1.33333 43.849 -1.33333 46.9282 4L78.1051 58C81.1843 63.3333 77.3353 70 71.1769 70H8.82309C2.66468 70 -1.18432 63.3333 1.89488 58L33.0718 4Z",
    fill: "url(#paint0_linear_157_231)"
  }), /*#__PURE__*/React__default.createElement("rect", {
    x: "37",
    y: "21",
    width: "4",
    height: "26",
    rx: "2",
    fill: "#B8C4DA"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "39",
    cy: "55",
    r: "2",
    fill: "#B8C4DA"
  })), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "paint0_linear_157_231",
    x1: "29.2609",
    y1: "31.5",
    x2: "82.6437",
    y2: "85.0142",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: "#EAEEF4"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: "1",
    stopColor: "#EAEEF4",
    stopOpacity: "0"
  })), /*#__PURE__*/React__default.createElement("clipPath", {
    id: "clip0_157_231"
  }, /*#__PURE__*/React__default.createElement("rect", {
    width: "84",
    height: "74",
    fill: "white",
    transform: "translate(0.5)"
  }))));
};

AttentionSvg.defaultProps = {
  width: "85",
  height: "74",
  viewBox: "0 0 85 74",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg"
};
function AttentionIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: AttentionSvg
  }, props));
}

var DragSvg$1 = function DragSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("circle", {
    cx: "2",
    cy: "2",
    r: "2"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "2",
    cy: "10",
    r: "2"
  }), /*#__PURE__*/React__default.createElement("circle", {
    cx: "2",
    cy: "18",
    r: "2"
  }));
};

DragSvg$1.defaultProps = {
  width: "4",
  height: "20",
  viewBox: "0 0 4 20",
  fill: "black",
  xmlns: "http://www.w3.org/2000/svg"
};
function DragIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: DragSvg$1
  }, props));
}

var DragSvg = function DragSvg(props) {
  return /*#__PURE__*/React__default.createElement("svg", props, /*#__PURE__*/React__default.createElement("path", {
    d: "M21 11H3V9H21V11ZM21 13H3V15H21V13Z",
    fill: "#7B7B7B"
  }));
};

DragSvg.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function DragHandlerIcon(props) {
  return /*#__PURE__*/React__default.createElement(Icon, _extends({
    source: DragSvg
  }, props));
}

export { ArrowDownIcon, ArrowLeftIcon, ArrowRightIcon, AttentionIcon, CalendarIcon, CheckedIcon, CloseIcon, DragHandlerIcon, DragIcon, ErrorIcon, Icon, NotFoundIcon, OkIcon, SearchIcon };
